import React from 'react'
import { Button, Input, Form } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { getWorkSheet } from '../../services/offpriceServices'

export default function SearchForm({
  placeholder,
  text,
  onChange,
  onClear,
  onSearch,
}) {
  return (
    <Form onSubmit={onSearch}>
      <Input placeholder={placeholder} action onChange={onChange}>
        <input value={text} />
        <Button icon='delete' onClick={onClear} type='button'/>
        <Button type='submit'>Search</Button>
      </Input>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./components/header/SearchForm.js